export const addSearchParamToUrl = (name: string, value: string, location = window.location): string => {
  const { routerPath, searchString } = getHashParams(location);
  const search = new URLSearchParams(searchString);
  if (search.has(name)) {
    search.delete(name);
  }
  search.append(name, value);
  const hash = `#${routerPath}?${search}`;
  const link = location.origin + location.pathname + location.search + hash;
  return link;
};

export const getHashParams = (location: Location) => {
  const [routerPath, searchString] = location.hash.substring(1).split('?');
  return { routerPath, searchString };
};

/**
 * Build the shareable link for an embedded configurator: the HOST page's URL carrying the
 * short code in its query string, anchored at the iframe so the recipient lands on the
 * configurator rather than at the top of the page.
 *
 * The `#configuratorIframe` fragment is load-bearing in both directions (CP-1156). It is what
 * scrolls the recipient to the configurator — and it is also what makes host page anchor
 * handlers rewrite the address bar as `pathname + hash`, dropping the query string and the
 * short code with it. The code survives that only because `public/integration.js` reads the
 * host URL from the navigation timing entry, which `history.pushState` never touches.
 *
 * A host running a copy of that script from before this fix still loses the code. Keep the two
 * in step: do not emit this fragment anywhere without that recovery on the host side.
 */
export const addSearchParamToHostUrl = (name: string, value: string, location: Location): string => {
  const search = new URLSearchParams(location.search);
  search.set(name, value);
  return `${location.origin}${location.pathname}?${search}#configuratorIframe`;
};
